/**
 * ConsentBanner — slim, dismissible cookie/tracking notice. WEB ONLY.
 *
 * We run the Meta Pixel by default (disclosed in the privacy policy) but give
 * visitors a clear opt-out here. "Got it" dismisses; "Decline" opts out of the
 * pixel for good. Hidden in the native app and once a choice has been made.
 */
import React, { useState } from "react";
import { isNative } from "../../utils/platform";
import { setMetaOptOut } from "../../utils/metaPixel";

const GOLD = "#E2DD9F";
const KEY = "bam_consent_choice";

export default function ConsentBanner() {
  const [show, setShow] = useState(() => {
    if (isNative()) return false;
    try { return localStorage.getItem(KEY) !== "1"; } catch { return false; }
  });
  if (!show) return null;

  const close = () => { try { localStorage.setItem(KEY, "1"); } catch {} setShow(false); };
  const accept = () => { setMetaOptOut(false); close(); };
  const decline = () => { setMetaOptOut(true); close(); };

  return (
    <div role="dialog" aria-label="Privacy notice" className="bam-consent" style={{
      position: "fixed", left: 12, right: 12, bottom: 12, zIndex: 9000,
      maxWidth: 560, margin: "0 auto",
      background: "rgba(14,14,14,0.97)", backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)",
      border: `1px solid ${GOLD}33`, borderRadius: 14,
      boxShadow: "0 14px 44px rgba(0,0,0,0.55)",
      padding: "14px 16px", fontFamily: "'DM Sans', sans-serif",
      display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap",
    }}>
      {/* On phones it sits at the top, slimmer (2026-11-04 sweep): at the bottom it wrapped to ~125px and covered the
          pages' sticky Enroll and Start buttons until dismissed. */}
      <style>{`@media (max-width: 640px) {
        .bam-consent { top: calc(env(safe-area-inset-top, 0px) + 8px) !important; bottom: auto !important; left: 8px !important; right: 8px !important;
          padding: 10px 12px !important; gap: 10px !important; flex-wrap: nowrap !important; }
        .bam-consent > div:first-of-type { min-width: 0 !important; font-size: 11.5px !important; line-height: 1.4 !important; }
        .bam-consent button { padding: 7px 10px !important; font-size: 12px !important; }
      }`}</style>
      <div style={{ flex: 1, minWidth: 220, fontSize: 12.5, lineHeight: 1.5, color: "#C9C4B6" }}>
        We use cookies and the Meta Pixel to measure our ads and improve the site. See our{" "}
        <a href="/#/privacy" style={{ color: GOLD, textDecoration: "underline" }}>Privacy Policy</a>.
      </div>
      <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
        <button onClick={decline} style={{
          padding: "8px 14px", borderRadius: 8, fontSize: 12.5, fontWeight: 700,
          background: "transparent", color: "#9A958A", border: "1px solid rgba(255,255,255,0.14)", cursor: "pointer",
        }}>Decline</button>
        <button onClick={accept} style={{
          padding: "8px 16px", borderRadius: 8, fontSize: 12.5, fontWeight: 800,
          background: GOLD, color: "#0A0A0A", border: "none", cursor: "pointer",
        }}>Got it</button>
      </div>
    </div>
  );
}
